export function formatCard(value) {
  return "**** **** **** " + value.substring(12);
}
